export default {

    getWeatherIcon(weather) {
        console.log(weather);
        let icon = require("@/assets/icon/weather/default.svg");
        if (weather) {
            weather = weather.trim();
            if (weather === "晴") {
                icon = require("@/assets/icon/weather/sunny.svg")
            }
            if (weather.indexOf("晴") > -1 && weather.indexOf("云") > -1) {
                icon = require("@/assets/icon/weather/sunny-cloudy.svg")
            }
            if (weather === "阴" || weather.indexOf("云") > -1 || weather === "平静") {
                icon = require("@/assets/icon/weather/cloudy.svg")
            }
            if (weather.indexOf("风") > -1) {
                icon = require("@/assets/icon/weather/wind.svg")
            }
            if (weather.indexOf("雨夹雪") > -1 || weather.indexOf("雨雪") > -1 || weather.indexOf("冻雨") > -1) {
                icon = require("@/assets/icon/weather/sleet.svg")
            }
            if (weather.indexOf("雨") > -1) {
                icon = require("@/assets/icon/weather/rain.svg")
            }
            if (weather.indexOf("大雨") > -1) {
                icon = require("@/assets/icon/weather/heavy-rain.svg")
            }
            if (weather.indexOf("暴雨") > -1) {
                icon = require("@/assets/icon/weather/heavy-rain.svg")
            }
            if (weather.indexOf("雷阵雨") > -1) {
                icon = require("@/assets/icon/weather/thunderstorm.svg")
            }
            if (weather.indexOf("雾") > -1 || weather.indexOf("霾") > -1) {
                icon = require("@/assets/icon/weather/fog.svg")
            }
            if (weather.indexOf("雪") > -1) {
                icon = require("@/assets/icon/weather/snow.svg")
            }
            if (weather.indexOf("冰雹") > -1) {
                icon = require("@/assets/icon/weather/hail.svg")
            }
        }
        return icon;
    },
}